import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BuscarOrdemServicoIn {
    listaOrdemServicoIdIgnorada: Array<any>;
    contratoId: number;
    codigo: String;
    enderecoId: String;
    listStatusOs: Array<number>;
    paginaAtual: number;
    tecnicoFiltro: String;
    status: String;
    dataCriacaoFiltro: Date;
    dataAgendadaFiltro: Date;
    dataEncerramentoFiltro: Date;
    buscaFiltro: String;
    motivoFiltro: String;
}
